<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Invoice Items"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create invoice items."
      @on-submit="createInvoiceItemsImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Invoice Items Template.xlsx"
              :file-provider="$importsAPI.getInvoiceItemsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'InvoiceItemsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'invoice-items-imports-add-modal',
    };
  },
  methods: {
    createInvoiceItemsImport(data, handleCreate) {
      handleCreate(this.$importsAPI.invoiceItemsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
